import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

/**
 * Hook to track page views on SPA route changes
 * Essential for accurate GA4 reporting in React Router apps
 */
export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    // Track page view on every route change
    trackPageView(location.pathname);
  }, [location.pathname]);
}
